import React from "react";
import { useFormik, FormikProvider, Form, useField } from "formik";
import * as Yup from "yup";
import PropType from "prop-types";

export const TextInputLiveFeedback = ({ label, helpText, ...props }) => {
  const [field, meta] = useField(props);

  // Show inline feedback if EITHER
  // - the input is focused AND value is longer than 2 characters
  // - or, the has been visited (touched === true)
  const [didFocus, setDidFocus] = React.useState(false);
  const handleFocus = () => setDidFocus(true);

  return (
    <div className={`form-control`}>
      <div className="flex items-center space-between">
        <label htmlFor={props.id} className="form-label">
          {label}
        </label>
      </div>
      <input
        className="form-input"
        {...props}
        {...field}
        aria-describedby={`${props.id}-feedback ${props.id}-help`}
        onFocus={handleFocus}
      />
    </div>
  );
};

TextInputLiveFeedback.propTypes = {
  id: PropType.number.isRequired,
  label: PropType.string.isRequired,
};

export default function ResetPasswordForm(props) {
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const formik = useFormik({
    initialValues: {
      password: "",
      passwordConfirm: "",
    },
    onSubmit: async (values) => {
      await sleep(500);

      props.onSubmit(values.password, values.passwordConfirm);
    },
  });

  return (
    <FormikProvider value={formik}>
      <Form>
        <TextInputLiveFeedback
          label="Password"
          id="reset-password"
          name="password"
          type="password"
        />
        <br />
        <TextInputLiveFeedback
          label="Confirm Password"
          id="reset-password-confirm"
          name="passwordConfirm"
          type="password"
        />
        <br />
        {props.errorMessage !== undefined ? <p>{props.errorMessage}</p> : null}
        <div>
          <button className="form-submit" type="submit">
            Submit
          </button>
        </div>
      </Form>
    </FormikProvider>
  );
}

ResetPasswordForm.propTypes = {
  onSubmit: PropType.func.isRequired,
};
